// Itens de treino (exercise) como no Tibia Global, mas batendo 5x mais rápido (decisão do Arthur, 15/10): cada uso, a cada
// 0,4 s, dá 7 tentativas na skill (ou 600 de mana gasta no magic level) num boneco de treino. O presente inicial tem 100 usos.

export type ExerciseSkill = 'sword' | 'axe' | 'club' | 'distance' | 'magic' | 'fist' | 'shielding' | 'fishing';
export interface ExerciseDef { name: string; skill: ExerciseSkill; far: boolean; label: string }

/** Itens de treino por nome (training = presente de 100 usos; exercise/durable/lasting = versões da loja). */
export const EXERCISE: Record<string, ExerciseDef> = {};
for (const [base, skill, far, label] of [
  ['sword', 'sword', false, 'Espada'], ['axe', 'axe', false, 'Machado'], ['club', 'club', false, 'Clava'],
  ['bow', 'distance', true, 'Arco'], ['rod', 'magic', true, 'Rod'], ['wand', 'magic', true, 'Wand'],
  ['wraps', 'fist', false, 'Faixas (monk)'], ['shield', 'shielding', false, 'Escudo'],
] as const) {
  for (const pre of ['training', 'exercise', 'durable exercise', 'lasting exercise']) {
    EXERCISE[`${pre} ${base}`] = { name: `${pre} ${base}`, skill, far, label };
  }
}
/** 2 s no Global ÷ 5 */
export const EXERCISE_INTERVAL = 400;
export const EXERCISE_TRIES = 7;
export const EXERCISE_MANA = 600;
export const GIFT_CHARGES = 100;
/** Opções do presente inicial (nomes do catálogo). */
export const GIFT_OPTIONS = ['training sword', 'training axe', 'training club', 'training bow', 'training rod', 'training wand', 'training wraps', 'training shield'];

// Treino offline igual ao Tibia Global (Canary, creaturescripts/player/offline_training.lua):
// - escolha uma skill (fist, sword, axe, club, distance ou magic level, sempre com shielding junto) e saia do jogo na cidade;
// - precisa ficar fora pelo menos 10 minutos; treina até 12 horas por saída, gastando o "tempo de treino offline" acumulado;
// - o tempo acumula enquanto você fica fora sem treinar (máximo 12 horas guardadas; personagem novo começa com 12 horas);
// - corpo a corpo: 1 tentativa a cada 4 s (velocidade de ataque 2 s ÷ 2); distância: 1 a cada 8 s; magic level: a mana que a
//   vocation promovida regenera (2 de mana a cada 2 s no sorcerer/druid, 3 s no paladin, 6 s no knight/monk); shielding: 1 a cada 4 s.
export const OFFLINE_TRAIN_MAX = 12 * 3600;
export const OFFLINE_TRAIN_MIN = 600;
export const OFFLINE_SKILLS_ALL: ExerciseSkill[] = ['fist', 'sword', 'axe', 'club', 'distance', 'magic', 'fishing'];
export const OFFLINE_SKILLS: Record<string, ExerciseSkill[]> = {
  knight: OFFLINE_SKILLS_ALL, paladin: OFFLINE_SKILLS_ALL, sorcerer: OFFLINE_SKILLS_ALL, druid: OFFLINE_SKILLS_ALL, monk: OFFLINE_SKILLS_ALL,
};
/** segundos por tique de mana da vocation promovida (gainmanaticks do Canary) — 2 de mana por tique */
export const OFFLINE_MANA_TICK: Record<string, number> = { sorcerer: 2, druid: 2, paladin: 3, knight: 6, monk: 6 };
